module.exports = __webpack_public_path__ + "assets/img/4-m.e691b4d8.jpg";